import { Outlet, useLocation } from "react-router-dom";
import Layout from "../components/ui/Layout";
import CreateAction from "../components/operational/createAction";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import myUserSlice from "../redux/myUserSlice";
import { useNavigate } from "react-router-dom";
import myAppsSlice from "../redux/myAppsSlice";
import themeSlice from "../redux/themeSlice";
import { useSelector } from "react-redux";
function DashboardLayout() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const license = useSelector((state: any) => state.myUserSlice).license
  const getAllCategories = useCallback(async () => {
    //@ts-ignore
    const categories = await getCollection("category", "listCategory") || {}
  }, [])

  const getAllBranding = useCallback(async () => {
    //@ts-ignore
    const brands = await getCollection("brand", "listProductBrand") || {}
  }, [])

  const getCollection = useCallback(async (type: string, url: string, id: string, page = 1, skip: boolean) => {
    const response = await CreateAction({
      method: 'post',
      path: `/${url}`,
      data: { id, page },
      headers: {
        "Content-Type": "application/json"
      },
      showPreLoader: false,
      isFileUploading: false,
      hideToastMessages: true

    });


    if (response?.error) return navigate("/dashboard/")

    const collectionData = response?.result?.resultData?.data
    if (!collectionData) return navigate("/dashboard/")

    const newRowCount = response?.result?.resultData?.count
    const limit = response?.result?.resultData?.limit
    const collections = {}
    collectionData?.forEach((element: any) => {
      if (element?.id && element?.name) {
        const collection = {
          value: element?.id,
          label: element?.name,
          image: "",
          type,
          parentId: element?.parentId,
          data: { ...element, type },
        }
        if (collection && element?.id && element?.name)
          //@ts-ignore
          collections[element.id] = collection
      }
    })


    const filteredCollections = Object.values(collections).filter(brand => brand)
    const hashMap = {}
    filteredCollections.forEach(item => {
      //@ts-ignore
      hashMap[item.value] = { image: null, text: item?.name, id: item.value }
    })
    //@ts-ignore
    dispatch(themeSlice.actions.setImageHashMap(hashMap))
    if (type === "brand")
      //@ts-ignore
      dispatch(themeSlice.actions.setBrands(collections))
    if (type === "category")
      //@ts-ignore
      dispatch(themeSlice.actions.setCategories(collections))
    if ((newRowCount / limit) > page && !skip) {
      const maxNum = Math.ceil(newRowCount / limit)
      for (let i = 1; i < maxNum; i++) {
        getCollection(type, url, id, i + 1, true)
      }
    }
    else if (type === "category" && page * limit >= newRowCount) {
      //@ts-ignore
      dispatch(themeSlice.actions.setCategoriesWithParentId(collections))
    }
  }, [])



  useEffect(() => {
    //@ts-ignore
    dispatch(themeSlice.actions.clearCollection())
    if (!license?.isWebView) {
      getAllBranding()
      getAllCategories()

    }
  }, [])

  return (
    <Outlet />
  );
}

export default DashboardLayout;